export const MOBILE_APP_VERSION_WARNING =
  'This Loyalty Program type requires at least Moka v.22.6 on iOS ' +
  'and Moka v.12.6 on Android.';
